<template>
    <div>
        <app-layout>
            <template #header>
                <AppHead title="Payout Settings" />
                <h2 class="title">Payout Settings</h2>
                <flash-messages />
            </template>

            <div class="py-2">
                <div>
                    <div class="bg-white">

                        <div class="grid grid-cols-12 mt-3">
                            <div class="col-span-6 sm:col-span-9">
                                <div class="bg-grey p-3">
                                    <div class="d-flex mb-2">
                                        <img class="payout-logo mr-2" src="/images/stripe.png" />
                                        <img class="payout-logo mr-2 py-2" src="/images/plaid.png" />
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-lg-6">
                                            <p class="mb-3 mb-lg-0 text-size-small alert alert-secondary">Mobile Tool
                                                Network has partnered with Stripe and Plaid to allow Mobile Tool Trucks to
                                                take ACH and Credit Card payments within minutes of registering</p>
                                        </div>
                                    </div>
                                    <div class="mt-3" v-if="needs_stripe_info">
                                        <h5>First Steps: Finish setting up your Stripe Connect Account</h5>
                                        <jet-button icon="fab fa-cc-stripe" :goesTo="route('user.stripeInfo')">Connect
                                            Stripe</jet-button>
                                    </div>
                                </div>
                                <div class="card-payment mt-2 p-3">

                                    <p class="mb-4 px-3 lh-regular"><i
                                            class="fas fa-info-circle text-dark fa-lg mr-2"></i>Select a payout method to
                                        safely and securely start taking transactions and receiving payments.</p>
                                    <div class="row col-12 col-lg-10 p-0 m-0">
                                        <div class="col-sm-6" v-if="has_payouts">
                                            <SelectCard :cards="cards" :form="form" :trash="false"
                                                blurb="Card must be a bank debit card" @setPaymentMethod="setPaymentMethod" />
                                        </div>
                                        <div class="col-sm-6">
                                            <SelectAccount :banks="banks" :link_token="link_token" :form="form"
                                                bankRoute="mtd.payout.addbank" :form_bank="formBank" :canDelete="false"
                                                @setPaymentMethod="setPaymentMethod" @bankAdded="updateSelected" />
                                        </div>
                                    </div>
                                </div>
                                <div class="bank-payment p-3"></div>
                            </div>

                            <div class="bottom-button px-2" v-if="form.stripe_payment_method">
                                <div class="px-3 pb-3">
                                    <jet-button class="px-5" btnStyle="success" :disable="form.processing"
                                        @click="updateDefault()">Update Payout Method</jet-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddCard :routeUrl="route('mtd.payout.addcard')" :formCard="formCard" @cardUpdated="updateSelected" />
        </app-layout>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import AddCard from '@/Components/Modals/AddCard'
import SelectCard from '@/Components/Payment/SelectCard'
import SelectAccount from '@/Components/Payment/SelectAccount'

export default {
    components: {
        AppLayout,
        FlashMessages,
        JetDialogModal,
        JetDangerButton,
        AddCard,
        SelectCard,
        SelectAccount
    },
    props: {
        items: Array,
        stripe_intent: String,
        payment_types: Array,
        stripe_key: String,
        cards: Array,
        banks: Array,
        order_total: Number,
        link_token: String,
        needs_stripe_info: Boolean,
        has_payouts: Boolean
    },
    data() {
        return {
            paymentType: 'Credit Card',
            stripe: null,
            form: this.$inertia.form({
                stripe_payment_method: null,
            }),
            formCard: this.$inertia.form({
                card_name: null,
                card_number: null,
                card_exp_month: null,
                card_exp_year: null,
                card_cvc: null,
                card_zip: null,
            }),
            formBank: this.$inertia.form({
                public_token: null,
                account_id: null
            })
        }
    },
    mounted() {
        this.updateSelected();
    },
    methods: {
        updateSelected() {
            this.cards.forEach(function (card) {
                if (card.default_for_currency) this.form.stripe_payment_method = card.id;
            }, this);
            this.banks.forEach(function (bank) {
                if (bank.default_for_currency) this.form.stripe_payment_method = bank.id;
            }, this);
        },
        setPaymentMethod(e, id) {
            if (e.target.checked) this.form.stripe_payment_method = id;
        },
        setPaymentType(e, code) {
            if (e.target.checked) {
                this.paymentType = code;
                this.form.stripe_payment_method = null;
            }
        },

        updateDefault() {
            this.form.post(this.route('user.updateDefaultPayout'));
        }
    },
}
</script>

<style>
.gallery-thumbnail img {
    width: 120px;
}

.payout-logo {
    height: 40px;
}
</style>
